webpackJsonp([72],{

/***/ 1192:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1193);


/***/ }),

/***/ 1193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(193);

var _datetime2 = _interopRequireDefault(_datetime);

var _pt = __webpack_require__(745);

var _pt2 = _interopRequireDefault(_pt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('pt', _pt2.default);

/***/ })

},[1192]);


// WEBPACK FOOTER //
// app/datetime.pt-69f7bf953623498ce076.js